import { render, staticRenderFns } from "./UserTypeViewedReports.vue?vue&type=template&id=527ebab7&scoped=true"
import script from "./UserTypeViewedReports.vue?vue&type=script&lang=js"
export * from "./UserTypeViewedReports.vue?vue&type=script&lang=js"
import style0 from "./UserTypeViewedReports.vue?vue&type=style&index=0&id=527ebab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ebab7",
  null
  
)

export default component.exports